import { environment } from '../../../environments/environment';
export class ConstService {

    public static defaultUrl: string = '';
    public static key: string = 'Abcd1234;;df';
    public static readonly ID_USER: string = 'USER_DEFAULT_INTEGRACIONES';
    
    private static host = environment.replication
    ? 'https://'
    :environment.production
        ? 'https://'
        : 'https://';
        
    public static authUrl = environment.replication
        ? ConstService.host + 'replauth.defontana.com/auth/token'
        :environment.production
        ? ConstService.host + 'auth.defontana.com/auth/token'
        : ConstService.host + 'certauth.defontana.com/auth/token';

    public static URLApi: string = environment.replication
        ? ConstService.host + 'replportal-api.defontana.com/api'
        :environment.production
        ? ConstService.host + 'portal-api.defontana.com/api'
        // : ConstService.host + 'localhost:7104'; 
         : ConstService.host + 'certportal-api.defontana.com/api';
    
    public static beamerHost: string = 'https://app.getbeamer.com/news?app_id=dRfgGVhZ46940';
    public static intercom_key: string = 'd7im2cqy'
             
    public static systemUrl(service: string): string {
        if (environment.production) {
            switch ((service || '').toLowerCase()) {
                case 'pyme': return ConstService.host + 'awspyme.defontana.com';
                case 'silver': return ConstService.host + 'ssilver.defontana.com';
                case 'golden': return ConstService.host + 'awsgolden.defontana.com';
                case 'platinum': return ConstService.host + 'platinum.defontana.com';
                case 'internacional':
                case 'international': return ConstService.host + 'international.defontana.com';
                default: return ConstService.host + 'trial.defontana.com';
            }
        }
        switch ((service || '').toLowerCase()) {
            case 'pyme': return ConstService.host + 'certnovapyme.defontana.com';
            case 'silver': return ConstService.host + 'certnovasilver.defontana.com';
            case 'golden': return ConstService.host + 'certnovagolden.defontana.com';
            case 'platinum': return ConstService.host + 'certnovaplatinum.defontana.com';
            case 'internacional':
            case 'international': return ConstService.host + 'certnovainternacional.defontana.com';
            default: return ConstService.host + 'certnovatrial.defontana.com';
        }
    }
}
